import React from "react";
import { connect } from "react-redux";
import actionWays from '../../redux/actions';
import { withRouter } from 'react-router-dom'
import { MenuUnfoldOutlined } from '@ant-design/icons';
import {  PAGE_NAME } from '../../config'

class Top extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
  
    
    render() {
        return (
            <div id='topId' className={'backgroundFixed row fixNavView'}>
                <div className="col-lg-2"></div>
                <div className='col-lg-8' >
                    <nav style={{ marginBottom: '0', background: 'none', border: 'none', color: '#fff' }} className={'colorFixed navbar navbar-default'}>
                        <div className="container-fluid">
                            <div className="navbar-header" style={{ lineHeight: '60px' }}>
                                <div id="logo"></div>
                                <a className={ 'colorFixed navbar-brand'} style={{ height: '60px', padding: '20px 15px', color: '#fff',}} href="/">{PAGE_NAME}</a>
                            </div>
                        </div>
                    </nav>
                </div>
                <div className="col-lg-2"></div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
        userUnitInfo: state.userUnitInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
        saveUnitInfo: (...args) => dispatch(actionWays.saveUnitInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Top))
